export default [
  {
    path: "/additionalWork",
    name: "additionalWork",
    meta: {
      layout: "main"
    },
    component: () => import("@/views/additionalWork/index")
  }
];
